import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { HomepageMainComponent } from './components/main/main.component';

const routes: Routes = [
  {
    path: '',
    component: HomepageMainComponent,
    data: {
      title: 'Crowdfunding India - Best Crowdfunding Platform & Website - Ketto',
      dontLoad: 'vwo',
      page_name: 'home',
      category: 'home',
      lastOrderSkip: true
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomepageRoutingModule { }
